module.exports = __webpack_public_path__ + "img/sucot-2016-thumbnail.9e2c4cc2.jpg";